import Box from "@material-ui/core/esm/Box";
import Divider from "@material-ui/core/esm/Divider";
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValueLoadable } from 'recoil';
import { customerPendingPrivilegesPagination, searchCustomerPendingPrivileges } from 'api/privileges/getCustomerPendingPrivileges';
import Pagination from 'components/Pagination/Pagination';
import Spinner from 'components/Spinner/Spinner';
import { BoldSubtitle, Title } from 'components/Text';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import checkLoadable from 'utils/recoil/checkLoadable';
import useStyles from './AccessStyles';
import PendingPrivilegeRow from './PendingPrivilegeRow';
export default function PendingPrivilegeList() {
  const {
    customer
  } = useCurrentCustomer();
  const {
    pendingPrivilege: pendingPrivilegeClass,
    column,
    emailColumn,
    conditionalColumn
  } = useStyles();
  const {
    t
  } = useTranslation();
  const [pagination, setPagination] = useRecoilState(customerPendingPrivilegesPagination);
  const pendingPrivilegesLoadable = useRecoilValueLoadable(searchCustomerPendingPrivileges(customer?.id));
  const {
    contents: pendingPrivileges,
    loading
  } = checkLoadable(pendingPrivilegesLoadable);
  if (loading) return /*#__PURE__*/React.createElement(Spinner, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    mb: 3
  }, /*#__PURE__*/React.createElement(Title, {
    isBold: true
  }, t('access_management.users_with_pending_access'))), /*#__PURE__*/React.createElement("div", {
    className: pendingPrivilegeClass
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx(column, emailColumn)
  }, /*#__PURE__*/React.createElement(BoldSubtitle, null, t('access_management.user_email'))), /*#__PURE__*/React.createElement("div", {
    className: clsx(column, conditionalColumn)
  }, /*#__PURE__*/React.createElement(BoldSubtitle, null, t('access_management.link_sent'))), /*#__PURE__*/React.createElement("div", {
    className: clsx(column, conditionalColumn)
  }, /*#__PURE__*/React.createElement(BoldSubtitle, null, t('access_management.link_valid_to')))), /*#__PURE__*/React.createElement(Divider, null), pendingPrivileges?.totalResults ? /*#__PURE__*/React.createElement(React.Fragment, null, pendingPrivileges?.results?.map(pendingPrivilege => /*#__PURE__*/React.createElement("div", {
    key: pendingPrivilege.id
  }, /*#__PURE__*/React.createElement(PendingPrivilegeRow, {
    pendingPrivilege: pendingPrivilege
  }), /*#__PURE__*/React.createElement(Divider, null))), /*#__PURE__*/React.createElement(Pagination, {
    totalResults: pendingPrivileges?.totalResults ?? 0,
    handlePagination: setPagination,
    paginationParams: pagination,
    rowsPerPageOptions: [5, 10, 30, 100]
  })) : /*#__PURE__*/React.createElement(Title, {
    align: "center"
  }, t('access_management.no_pending_privileges')));
}